import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import "./LandCarousel.css"; // Import the CSS file

function LandCarousel() {
  return (
    <Container>
      <Carousel>
        {/* <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/l1.jpg"
            alt="First slide"
            style={{borderRadius: "25px"}}
          />
          <Carousel.Caption>
            <h3>First Landscaping</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item> */}
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/l2.jpg"
            alt="Second slide"
            style={{borderRadius: "25px"}}
          />
          <Carousel.Caption>
            <h3>First Landscaping</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/land3.jpg"
            alt="Third slide"
            style={{borderRadius: "25px"}}
          />
          <Carousel.Caption>
            <h3>Second Landscaping</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/l3.jpg"
            alt="Second slide"
            style={{borderRadius: "25px"}}
          />
          <Carousel.Caption>
            <h3>Thiird Landscaping</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default LandCarousel;
